module.exports = __webpack_public_path__ + "img/CATree3_Side.5df5ab9e.png";